(function () {
  const configScript = document.getElementById('sas-infinite-scroll-config');

  const infiniteConfig = JSON.parse(configScript.textContent);
  const scrollMode = infiniteConfig.mode;

  let observer = null;
  let loading = false;

  function getProductList(root) {
    if (!root) return null;
    return root.classList.contains('product-grid') ? root : root.querySelector('ul.product-grid');
  }

  function initAutoLoadMore() {
    const grid = document.querySelector('#product-grid');
    const button = document.querySelector('.js-load-more');

    if (!grid || !button) return;

    loading = false;

    observer?.disconnect();
    observer = null;

    button.removeEventListener('click', loadMore);
    button.addEventListener('click', loadMore);

    if (scrollMode === 'automatic') {
      observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && !loading) {
            observer.unobserve(button);
            button.style.border = 'none';
            button.click();
          }
        },
        { rootMargin: '0px 0px 800px 0px' },
      );

      observer.observe(button);
    }
  }

  function loadMore(e) {
    e.preventDefault();
    if (loading) return;

    const button = e.currentTarget;
    const grid = document.querySelector('#product-grid');
    const list = getProductList(grid);
    const nextUrl = button.dataset.nextUrl;

    if (!nextUrl) {
      observer?.disconnect();
      button.closest('.sas-load-more-wrapper')?.remove();
      return;
    }

    loading = true;
    button.classList.add('loading');

    observer?.disconnect();

    fetch(nextUrl)
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newList = getProductList(doc.querySelector('#product-grid'));
        const newItems = newList ? Array.from(newList.children) : [];
        const newButton = doc.querySelector('.js-load-more');

        if (!newItems.length || !list) {
          button.closest('.sas-load-more-wrapper')?.remove();
          return;
        }

        newItems.forEach((el) => list.appendChild(el));

        if (newButton && newButton.dataset.nextUrl) {
          button.dataset.nextUrl = newButton.dataset.nextUrl;

          if (scrollMode === 'automatic') {
            requestAnimationFrame(() => {
              observer?.observe(button);
            });
          }
        } else {
          button.closest('.sas-load-more-wrapper')?.remove();
          return;
        }

        loading = false;
        button.classList.remove('loading');
      })
      .catch(() => {
        loading = false;
        button.classList.remove('loading');
      });
  }

  document.addEventListener('DOMContentLoaded', initAutoLoadMore);
  document.addEventListener('collection:grid:updated', initAutoLoadMore);
  document.addEventListener('shopify:section:load', initAutoLoadMore);
})();
